/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalAlert
 */
export interface GlobalAlert {
    /**
     * 
     * @type {string}
     * @memberof GlobalAlert
     */
    text: string;
}

export function GlobalAlertFromJSON(json: any): GlobalAlert {
    return GlobalAlertFromJSONTyped(json, false);
}

export function GlobalAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalAlert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function GlobalAlertToJSON(value?: GlobalAlert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}


